var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRpoetSubCat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2891,
    cy: 25.5,
    r: 25,
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_67982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2891,
    y: 10.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_67982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6641 19.7017V38H15.9141V13H27.9624L34.6641 19.7017ZM28.4141 19.25H31.9907L28.4141 15.6733V19.25ZM33.1016 36.4375V20.8125H26.8516V14.5625H17.4766V36.4375H33.1016ZM23.7266 30.1875H26.8516V34.875H23.7266V30.1875ZM19.0391 27.0625H22.1641V34.875H19.0391V27.0625ZM28.4141 23.9375H31.5391V34.875H28.4141V23.9375Z",
    fill: "#F6EFE9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpoetSubCat);
export default __webpack_public_path__ + "static/media/RpoetSubCat.81ea7d69fa4ec76117989e2f73f73c8b.svg";
export { ForwardRef as ReactComponent };